import { createContext } from "react";

// set the defaults
const SyncExpressionContext = createContext({
  syncOrderID: null,
  syncOperationID: null,
  syncOrderStatus: null,
  syncPeriod: [],
  setSyncOrderID: (orderId) => {},
  setSyncOperationID: () => {},
  setSyncOrderStatus: () => {},
  setSyncPeriod: (dates) => {}
});

export default SyncExpressionContext;